export default __webpack_public_path__ + "static/media/Add.800a60be.svg";